import React from "react";
import { View } from "react-native";
import { TouchableOpacity } from "../Buttons";
import { Text } from "../Text";
import { quantityModifierStyles as styles } from "./styles";

type QuantityModifierProps = {
  quantity: number;
  setQuantity: (index: number) => void;
};
const QuantityModifier = ({
  quantity,
  setQuantity,
}: QuantityModifierProps): JSX.Element => {
  return (
    <View style={styles.container}>
      {Array.of(2, 3, 4, 5, 6, 7, 8, 9).map((index) => {
        let containerStyle = styles.unselectedButtonContainer;
        if (quantity === 1) {
          containerStyle = styles.buttonContainer;
        } else if (quantity === index) {
          containerStyle = styles.selectedButtonContainer;
        }
        return (
          <TouchableOpacity
            accessible
            accessibilityRole="button"
            accessibilityLabel={`Set quantity to ${index}`}
            onPress={() => {
              if (quantity === index) {
                setQuantity(1);
              } else {
                setQuantity(index);
              }
            }}
            key={index}
            style={containerStyle}
          >
            <Text style={styles.buttonText}>{index}</Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default QuantityModifier;
